// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__XDOLC","navbar-nav":"Nav_navbar-nav__Ctm95","nav-item":"Nav_nav-item__tS0tY"};